/* eslint-disable @typescript-eslint/no-shadow */
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AgendaSessaoService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

  listar(data) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/Listar', data)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }
  listarPorPeriodo(data) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/ListarPorPeriodo', data)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }
  exportar(data) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/exportar', data)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }
  listarPorComissao(idComissao, data) {
    return new Promise(async (resolve) => {
      this.http.get(`https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/ListarPorComissao?id=${idComissao}&data=${data}`)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }

  listarProgressao(radar) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/ListarProgresso?' + radar)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }

  listarPorTag(tags: string, processId: string): Promise<any> {
    const url = `https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/listarPorTag?${tags}&processId=${processId}`;
  
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => resolve(data),
        error => reject(error)
      );
    });
  }

  listarPorProjetoLista(model) {
    return new Promise(async (resolve) => {
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/listarPorProjetoLista', model)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  listarProgressaoPorProjetoLista(model) {
    return new Promise(async (resolve) => {
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/ListarProgressoPorProjetoLista', model)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/Obter?Id=' + id)
        .subscribe(data => {
          resolve(data);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }
  obterTexto(data) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/agendaSessao/ObterTexto?Data=' + data)
        .subscribe(response => {
          resolve(response);
        }, error => {

          // navigator.app.exitApp();
        });
    });
  }
}
